import { CustomSvgProps } from "types/Common";

export const ArrowNewRight = (props: CustomSvgProps) => {
  return (
    <svg
      width={props.width || "51"}
      height={props.height || "52"}
      fill="none"
      viewBox="0 0 51 52"
      {...props}
      style={{ ...props.style }}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.6921 46.9403C37.2571 46.9403 46.6323 37.565 46.6323 26.0001C46.6323 14.4352 37.2571 5.05994 25.6921 5.05994C14.1272 5.05994 4.75195 14.4352 4.75195 26.0001C4.75195 37.565 14.1272 46.9403 25.6921 46.9403Z"
        stroke="#606A78"
        strokeWidth="1.07692"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0547 33.3919L30.4256 26L23.0547 18.6082"
        stroke="#606A78"
        strokeWidth="1.07692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
